<div class="dash-shell">
  <header class="page-head">
    <nav class="page-head__crumbs" aria-label="Breadcrumb">
      <a class="page-head__crumb" routerLink="/dashboard">Home</a>
      <span class="page-head__sep" aria-hidden="true">/</span>
      <span class="page-head__crumb page-head__crumb--current" aria-current="page">
        Deleted businesses
      </span>
    </nav>
    <div class="page-head__bar">
      <div class="page-head__titles page-head__titles--icon">
        <span class="page-head__icon" aria-hidden="true"
          ><app-icon name="trash" [size]="24"
        /></span>
        <h1 class="page-head__title">Deleted businesses</h1>
        <p class="page-head__subtitle">
          Businesses you have deleted. Restore one to make it active again.
        </p>
      </div>
    </div>
  </header>

  @if (isLoading()) {
    <div class="loading-state" aria-label="Loading deleted businesses" aria-busy="true">
      @for (i of [1, 2, 3]; track i) {
        <span class="sg-skeleton sg-skeleton--text sg-skeleton--w100"></span>
      }
    </div>
  } @else if (loadError()) {
    <div class="sg-empty sg-empty--error sg-empty--bordered">
      <app-icon name="x-circle" [size]="40" />
      <p class="sg-empty__title">Couldn't load deleted businesses</p>
      <p class="sg-empty__desc">Something went wrong on our side.</p>
      <button mat-stroked-button type="button" (click)="retryLoad()">
        <app-icon name="refresh" [size]="18" />
        Try again
      </button>
    </div>
  } @else if (entities().length === 0) {
    <div class="sg-empty sg-empty--bordered">
      <app-icon name="document" [size]="40" />
      <p class="sg-empty__title">No deleted businesses</p>
      <p class="sg-empty__desc">Businesses you delete will appear here and can be restored.</p>
      <a mat-stroked-button routerLink="/dashboard">Back to Home</a>
    </div>
  } @else {
    <ul class="deleted-list" aria-label="Deleted businesses">
      @for (e of entities(); track e.short_id) {
        <li class="deleted-list__item">
          <mat-card appearance="outlined" class="deleted-card">
            <mat-card-content class="deleted-card__content">
              <div class="deleted-card__info">
                <h2 class="deleted-card__name">{{ e.name }}</h2>
                <p class="deleted-card__meta">{{ getTypeLabel(e.type) }} &middot; {{ e.reg_no }}</p>
              </div>
              <button
                mat-stroked-button
                type="button"
                class="deleted-card__restore"
                [disabled]="isRestoring(e.short_id)"
                (click)="restore(e)"
                [attr.data-testid]="'restore-' + e.short_id"
              >
                <app-icon name="restore" [size]="18" />
                <span>Restore</span>
              </button>
            </mat-card-content>
          </mat-card>
        </li>
      }
    </ul>
  }
</div>
